export default {
	gtmId: process.env.REACT_APP_GTM_ID as string
}
